export default function(rangeType, start, end) {
  var retArray = []
  var startDate = new Date(start)
  var endDate = new Date(end)
  var date = startDate
  try {
    if (rangeType === 1) {
      retArray.push(
        date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      )
      while (date < endDate) {
        date = new Date(date.getTime() + 24 * 60 * 60 * 1000)
        retArray.push(
          date.getFullYear() +
            '-' +
            (date.getMonth() + 1) +
            '-' +
            date.getDate()
        )
      }
    } else if (rangeType === 2) {
      retArray.push(
        date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      )
      while (date < endDate) {
        date = new Date(date.getTime() + 24 * 60 * 60 * 1000 * 7)
        retArray.push(
          date.getFullYear() +
            '-' +
            (date.getMonth() + 1) +
            '-' +
            date.getDate()
        )
      }
    } else if (rangeType === 3) {
      while (date <= endDate) {
        var _y = date.getFullYear()
        var _m = date.getMonth() + 1
        retArray.push(_y + '/' + _m)
        if (_m === 12) {
          date = new Date(_y + 1 + '-1-1')
        } else {
          date = new Date(_y + '-' + (_m + 1) + '-1')
        }
      }
    }
    return retArray
  } catch (e) {
    return []
  }
}
